/** @format */
import * as yup from "yup";

export const passwordRecoverySchema = yup.object().shape({
  email: yup.string().email("Please enter email").required("Email is required"),
});
